export enum NavLinkVariant {
  MAIN = '--main',
  SUB = '--sub',
  DECORATIVE = '--decorative',
  INVISIBLE = '--invisible',
  ICON = '--icon',
}
